class TransparentHeader {
  constructor() {
    this.header = document.querySelector("header");
    this.main = document.querySelector("main");
    this.transparentHeaderClass = document.querySelector(".transparent-header");
    this.transparentHeaderDiv = document.querySelector("div.transparent-header");
    this.solidHeaderClass = document.querySelector(".solid-header");
    this.events();
  }

  events() {
    console.log(this.transparentHeaderClass);
    // Check for the transparent-header class
    if (this.transparentHeaderClass && !this.solidHeaderClass) {
      // Add transparent-header class to header
      this.header.classList.add("transparent-header");
      // Start the event listener
      window.addEventListener("scroll", () => this.changeHeader());
    }
    // If main has the solid-header class, remove the transparent-header class
    if (this.solidHeaderClass) {
      this.transparentHeaderDiv.classList.remove("transparent-header");
      this.transparentHeaderDiv.classList.add("transparent-header__solid");
    }
  }

  changeHeader() {
    this.scrollPos = window.scrollY;
    if (this.scrollPos > 200) {
      this.transparentHeaderDiv.classList.add("transparent-header__solid");
      this.transparentHeaderDiv.classList.remove("transparent-header");
    } else {
      this.transparentHeaderDiv.classList.remove("transparent-header__solid");
      this.transparentHeaderDiv.classList.add("transparent-header");
    }
  }
}

export default TransparentHeader;
